import { render, staticRenderFns } from "./account-saldo-page.vue?vue&type=template&id=acc713e0&"
import script from "./account-saldo-page.vue?vue&type=script&lang=js&"
export * from "./account-saldo-page.vue?vue&type=script&lang=js&"
import style0 from "./account-saldo-page.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports